import React from 'react';
import { isEmpty } from 'lodash';
import format from 'string-template';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { length } from 'redux-form-validators';

import {
    FIRSTNAME_LENGTH,
    NAME_LENGTH,
    ACCOUNT_LABEL_MAX_LENGTH
} from '../../../../constants/form';
import { STATIC_ROOT } from '../../../../constants';

import {
    sendIbanCreateRequest,
    reset,
    setTimeoutId
} from '../../../../services/account/iban/actions';

import {
    FormComponent,
    TextInputFieldComponent,
    IBANInputFieldComponent,
    BICInputFieldComponent,
    LegendFieldComponent
} from '../../../form';
import SvgComponent from '../../../SvgComponent';

import './IbanFormComponent.scss';

const FORM_NAME = 'iban-form';

class IbanFormComponent extends React.Component {
    componentWillUnmount() {
        if (document && document.querySelector('#add-account-button')) {
            document.querySelector('#add-account-button').focus();
        }
    }

    submit = formData => {
        const { type, sendIbanCreateRequest, timeoutId } = this.props;

        clearTimeout(timeoutId);

        const data = {
            lastname: formData.ownerLastname,
            firstname: formData.ownerFirstname,
            label: formData.label,
            iban: formData.iban,
            bic: formData.bic,
            type: type
        };
        sendIbanCreateRequest(data, () => {
            if (document.getElementById('add-iban-success')) {
                document.getElementById('add-iban-success').scrollIntoView({ behavior: 'smooth' });
            }
        });
    };

    render() {
        const { i18n, i18nForm, createIbanFetching, errorSubmit, createIbanError } = this.props;

        return (
            <div className="add-account-form">
                <FormComponent
                    form={FORM_NAME}
                    classNameInputContainer="grid-2 has-gutter"
                    onSubmit={this.submit}
                    requestSubmit={createIbanFetching}
                    errorSubmit={errorSubmit}
                    submitText={i18n.CREATE_IBAN_CTA_CONFIRM}>
                    <LegendFieldComponent classNameInputContainer="full required">
                        {i18nForm.MANDATORY_FIELD}
                    </LegendFieldComponent>

                    <TextInputFieldComponent
                        name="ownerLastname"
                        placeholder={i18nForm.LABEL_LASTNAME}
                        label={i18nForm.LABEL_LASTNAME_TITULAIRE}
                        isRequired
                        validate={[
                            length({
                                max: NAME_LENGTH,
                                msg: format(
                                    i18nForm.TEXT_TOOLONG,
                                    NAME_LENGTH,
                                    NAME_LENGTH > 1 ? 's' : ''
                                )
                            })
                        ]}
                    />
                    <TextInputFieldComponent
                        name="ownerFirstname"
                        classNameInputContainer="one-half"
                        label={i18nForm.LABEL_FIRSTNAME_TITULAIRE}
                        isRequired
                        validate={[
                            length({
                                max: FIRSTNAME_LENGTH,
                                msg: format(
                                    i18nForm.TEXT_TOOLONG,
                                    FIRSTNAME_LENGTH,
                                    FIRSTNAME_LENGTH > 1 ? 's' : ''
                                )
                            })
                        ]}
                    />
                    <TextInputFieldComponent
                        name="label"
                        classNameInputContainer="one-half"
                        placeholder={i18nForm.LABEL_ACCOUNT}
                        label={i18nForm.LABEL_ACCOUNT}
                        validate={[
                            length({
                                max: ACCOUNT_LABEL_MAX_LENGTH,
                                msg: format(
                                    i18nForm.ACCOUNT_LABEL_SIZE_ERROR,
                                    ACCOUNT_LABEL_MAX_LENGTH
                                )
                            })
                        ]}
                    />
                    <IBANInputFieldComponent
                        name="iban"
                        placeholder={i18nForm.IBAN_CODE_DETAIL}
                        label={
                            <React.Fragment>
                                {i18nForm.IBAN_CODE}{' '}
                                <span className="label-detail">({i18nForm.IBAN_FORMAT})</span>
                            </React.Fragment>
                        }
                        classNameInputContainer="one-half mr50"
                        isRequired
                    />
                    <BICInputFieldComponent
                        name="bic"
                        placeholder={i18nForm.CODE_BIC_DETAIL}
                        label={
                            <React.Fragment>
                                {i18nForm.CODE_BIC}{' '}
                                <span className="label-detail">({i18nForm.CODE_BIC_DETAIL})</span>
                            </React.Fragment>
                        }
                        classNameInputContainer="one-half mr50"
                        isRequired
                    />
                    <React.Fragment>
                        {errorSubmit && (
                            <LegendFieldComponent classNameInputContainer="full color-err err-picto">
                                <div className="picto">
                                    <SvgComponent
                                        src={`${STATIC_ROOT}/picto-errors.svg`}
                                        width={20}
                                        height={20}
                                        aria-hidden="true"
                                    />
                                </div>
                                <div>{createIbanError}</div>
                            </LegendFieldComponent>
                        )}
                    </React.Fragment>
                </FormComponent>
            </div>
        );
    }
}

IbanFormComponent.propTypes = {
    type: PropTypes.number
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.PROFILE.IBAN,
        i18nForm: state.i18n.feature.form,
        createIbanFetching: state.account.iban.createIbanFetching,
        createIbanError: state.account.iban.createIbanError || '',
        errorSubmit: !isEmpty(state.account.iban.createIbanError),
        timeoutId: state.account.iban.resetTimeoutId
    };
}

const mapDispatchtoProps = {
    sendIbanCreateRequest,
    reset,
    setTimeoutId
};

export default connect(mapStateToProps, mapDispatchtoProps)(IbanFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/IbanFormComponent.js